<template lang="pug">
	.editor-control-input-angle(:style="{zIndex: rotateProcess ? 2000 : 2}" :class="{'change-process': changedValue !== null, [theme]: true}")
		.cursor-container(v-if="rotateProcess" :style="{cursor: ({x: 'ew-resize', y: 'ns-resize', 'xy': 'move'})[rotateProcess.propertyModifier]}" v-on:mouseup="stopRotation()")
		.input-title(v-if="title") {{title}}
		.control-number
			.number-input(v-on:wheel="processChangeValueByMouseWheel($event)")
				label
					input.form-control.form-control-sm(:value="getDisplayedValue()" v-on:keydown="startChangeValueByKeyPress($event)" v-on:keyup="changeValueByInput($event.target.value, null, $event, false)" v-on:change="changeValueByInput($event.target.value, null, $event)" v-on:focus="blockUpdate()" v-on:blur="unblockUpdate()")
			.angle-input(:class="{active: rotateProcess || changedValue !== null, changed: getDisplayedValue()}" v-on:mousedown="startRotation($event)" v-on:wheel="processChangeValueByMouseWheel($event)")
				.angle-center(ref="angle-center")
				.angle-direction(:style="{transform: `rotate(${getDisplayedValue()}deg)`}")
				.angle-default
</template>

<script>

	import Screen 							from './../../../mixins/screen'

	import { Elements }						from './../../../services/Elements'

	export default {
		name: 'InputAngle',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Switched",
				"Selected Screen Switched",
				"Selected Element Switched"
			],
			events: {
				"Selected Element Changed": function() {

					this.update();

				}
			}
		},
		components: {},
		props: ["title", "default", "value", "options", "theme"],
		data() {

			this.element = null;

			this.rotateProcess = null;
			this.keyPressProcess = null;

			return {
				showed: true,
				changedValue: null
			};

		},
		mounted() {

			window.addEventListener("mouseup", () => {

				if (this.rotateProcess) this.stopRotation();

			});

			window.addEventListener("mousemove", e => {

				if (this.rotateProcess) this.processRotation(e);

			});

			window.addEventListener("keydown", e => {

				if (e.keyCode === 16) {

					if (this.keyPressProcess) this.keyPressProcess.shiftKey = true;
					if (this.rotateProcess) this.rotateProcess.shiftKey = true;

					this.update();

				}

				if (e.keyCode === 17) {

					if (this.keyPressProcess) this.keyPressProcess.ctrlKey = true;
					if (this.rotateProcess) this.rotateProcess.ctrlKey = true;

					this.update();

				}

			});

			window.addEventListener("keyup", e => {

				if (this.keyPressProcess && (e.keyCode === 38 || e.keyCode === 40)) this.stopChangeValueByKeyPress();

				if (e.keyCode === 16) {

					if (this.keyPressProcess) this.keyPressProcess.shiftKey = false;
					if (this.rotateProcess) this.rotateProcess.shiftKey = false;

					this.update();

				}

				if (e.keyCode === 17) {

					if (this.keyPressProcess) this.keyPressProcess.ctrlKey = false;
					if (this.rotateProcess) this.rotateProcess.ctrlKey = false;

					this.update();

				}

			});

		},
		methods: {
			collectData() {

				this.element = Elements.SelectedElement;

				//console.log('collectData', this.default, this.value, this.options);

			},
			getDisplayedValue() {

				let value = this.changedValue !== null ? this.changedValue : this.value;

				if (value === undefined) value = this.default;

				if (this.options.controlOptions?.percent) value = `${parseInt(value * 100)}%`;
				else if (this.options.changes && "accuracy" in this.options.changes) value = parseInt(value * Math.pow(10, this.options.changes.accuracy)) / Math.pow(10, this.options.changes.accuracy);

				return value;

			},
			getValue() {

				let value = null;

				if (this.changedValue !== null) value = this.changedValue;
				else if (this.value !== undefined) value = this.value;
				else value = this.default;

				value = this.restoreValueType(value);

				return value;

			},
			setValue(value, fixAccuracy = true, forceUpdate = false) {

				if (this.options.changes && "max" in this.options.changes) {
					if (value > this.options.changes.max) value = this.options.changes.max;
				}

				if (this.options.changes && "min" in this.options.changes) {
					if (value < this.options.changes.min) value = this.options.changes.min;
				}

				this.changedValue = value;

				if (forceUpdate) this.$forceUpdate();
				else this.update();

				this.sendValue(this.getValue());

			},
			restoreValueType(value) {

				return parseFloat(value);

			},
			sendValue(value) {

				this.$emit('input', value);

				clearTimeout(this.sendTimeout);
				this.sendTimeout = setTimeout(() => {

					this.$emit('change', value);

					this.changedValue = null;

					this.update();

				}, 500);

			},
			isDisplayedValueChanged() {

				if (this.changedValue === null) return false;

				let changedValue = this.restoreValueType(this.changedValue),
					baseValue = this.restoreValueType(this.value);

				return JSON.stringify(changedValue) !== JSON.stringify(baseValue);

			},
			getChangeProcess() {

				return this.rotateProcess;

			},
			changeValueByInput(value, e = null, isSave = true) {

				if (!e || (e.keyCode !== 38 && e.keyCode !== 40)) {

					if (this.changedValue === null) this.changedValue = (this.value !== undefined && this.value !== null) ? this.value : this.default;

					let newValue = parseFloat(this.changedValue);

					value = parseFloat(value);

					newValue = value;

					if (_.isNaN(value)) value = undefined;

					if (value !== undefined) {

						this.changedValue = value;

						if (isSave) this.setValue(this.changedValue, false);

					}

				}

			},
			startChangeValueByKeyPress(e) {

				if (e.keyCode === 38 || e.keyCode === 40) {

					if (!this.keyPressProcess) {

						this.keyPressProcess = {
							increaser: e.keyCode === 40 ? -1 : 1,
							shiftKey: e.shiftKey
						};

						this.keyPressProcess.timeout = setTimeout(() => {

							this.changeValue(this.keyPressProcess.increaser, this.keyPressProcess.shiftKey, true);

							this.keyPressProcess.interval = setInterval(() => {

								this.changeValue(this.keyPressProcess.increaser, this.keyPressProcess.shiftKey, true);

							}, 50);

						}, 200);

						this.changeValue(this.keyPressProcess.increaser, this.keyPressProcess.shiftKey, true);

					}

					e.preventDefault();

				}

			},
			stopChangeValueByKeyPress() {

				if (this.keyPressProcess) {

					clearTimeout(this.keyPressProcess.timeout);
					clearInterval(this.keyPressProcess.interval);
					clearTimeout(this.keyPressProcess.stopTimeout);

					this.keyPressProcess = null;

				}

			},
			processChangeValueByMouseWheel(e) {

				this.changeValue(Math.sign(e.wheelDelta), e.shiftKey, true);

			},
			startRotation(e) {

				let clientRect = this.$refs['angle-center'].getBoundingClientRect();

				this.rotateProcess = {
					//active: true,
					messages: this.options.messages,
					downPointerPosition: {
						x: clientRect.x + clientRect.width / 2,
						y: clientRect.y + clientRect.height / 2
					},
					downElementAngle: this.getValue(Metadata.ElementPropertiesByCodename['angle'])
				};

				this.processRotation(e);

				this.$emit('startRotation', this.rotateProcess);

				console.log('startRotation', this.rotateProcess);

			},
			processRotation(e) {

				//if (this.rotateProcess.active) {

					let offsetX = (e.clientX - this.rotateProcess.downPointerPosition.x),
						offsetY = (e.clientY - this.rotateProcess.downPointerPosition.y);

					let angle = Math.atan(Math.abs(offsetY) / Math.abs(offsetX)) * 180 / Math.PI;

					if (offsetY >= 0 && offsetX <= 0) angle = 180 - angle;
					else if (offsetY <= 0 && offsetX <= 0) angle = 180 + angle;
					else if (offsetY <= 0 && offsetX >= 0) angle = 360 - angle;

					if (e.shiftKey && e.ctrlKey) {

						angle = Math.round(angle / 5) * 5;

					} else if (e.shiftKey) {

						angle = Math.round(angle / 45) * 45;

					} else if (e.ctrlKey) {

						angle = Math.round(angle / 15) * 15;

					}

					if (angle === 360) angle = 0;

					this.setValue(angle);

				/*} else {

					let dx = e.clientX - this.rotateProcess.downPointerPosition.x,
						dy = e.clientY - this.rotateProcess.downPointerPosition.y;

					this.rotateProcess.active = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)) > 5;

				}*/

			},
			stopRotation() {

				this.rotateProcess = null;

				this.$emit('stopRotation', this.rotateProcess);

				this.$forceUpdate();

			},
			changeValue(increaser, shiftKey, forceUpdate = false) {

				if (this.changedValue === null) this.changedValue = (this.value !== undefined && this.value !== null) ? this.value : this.default;

				let newValue = parseFloat(this.changedValue);

				newValue += (this.options.changes?.step || 1) * increaser * (shiftKey ? 10 : 1);

				this.setValue(newValue, false, forceUpdate);

			},
			blockUpdate() {

				// Запрещаем апдейт компонента пока фокус стоит в поле ввода информации
				this.updateBlocked = true;

			},
			unblockUpdate() {

				this.updateBlocked = false;

				// Пробуем через таймаут обновить компонент
				// Если updateBlocked к этому моменту всё ещё будет false то компонент обновится и отобразит новые клиентские данные
				// Это делается чтобы заблокировать обновление полей ввода пока пользователь не завершил их ввод
				// Без этого автообновления мешают печатать новые значения в полях типа coords
				clearTimeout(this.updateTimeout);
				this.updateTimeout = setTimeout(() => {

					this.update();

				}, 200);

			}
		}

	}
</script>

<style lang="sass">

	.editor-control-input-angle
		color: #f3f4f5
		display: flex
		flex-direction: row
		flex-wrap: nowrap
		min-height: 31px
		align-items: center

		.cursor-container
			position: fixed
			z-index: 2
			left: 0
			top: 0
			width: 100%
			height: 100%
			cursor: move

		.input-title
			display: flex
			justify-content: right
			overflow: hidden
			text-overflow: ellipsis
			color: var(--secondary)
			font-size: 0.85rem
			padding-right: 0.5rem
			cursor: default
			user-select: none

		.control-number
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			align-items: center
			justify-content: left

			.number-input
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				border-radius: 0.1rem
				color: rgba(255, 255, 255, 0.87)
				background-color: rgba(255, 255, 255, 0.05)
				border: 1px solid rgba(255, 255, 255, 0.09)
				transition: border-color 0.35s ease-in-out, box-shadow 0.35s ease-in-out, color 0.35s ease-in-out
				overflow: hidden
				width: 60px
				height: 24px

				label
					display: flex
					flex-direction: row
					flex-wrap: nowrap
					margin: 0
					padding: 0

				input
					margin: 0
					width: 58px
					height: 100%
					box-shadow: none
					outline: none !important
					border-radius: 0
					border: none
					background-color: transparent
					padding: 0 3px

			.angle-input
				position: relative
				width: 24px
				height: 24px
				border-radius: 24px
				background-color: rgba(255, 255, 255, 0.05)
				border: 1px solid rgba(255, 255, 255, 0.09)
				margin-left: 5px
				cursor: pointer
				user-select: none

				.angle-center
					position: absolute
					left: 9px
					top: 9px
					width: 2px
					height: 2px
					border-radius: 2px
					background-color: rgba(255, 255, 255, 0.09)
					border: 2px solid rgba(255, 255, 255, 0.09)

					&.changed
						border: 2px solid #383d47

				.angle-direction
					position: absolute
					left: 13px
					top: 10px
					width: 9px
					height: 0
					border: 1px solid #383d47
					transform-origin: -2px center
					transform: rotate(0deg)
					display: none

				.angle-default
					position: absolute
					left: 13px
					top: 10px
					width: 9px
					height: 0
					border-top: 2px solid rgba(255, 255, 255, 0.04)

				&.changed

					.angle-center
						border-color: #2d3139

					.angle-direction
						border-color: #2d3139
						display: block

				&.active
					border-color: #20a8d8

					.angle-center
						border-color: #20a8d8

					.angle-direction
						border-color: #20a8d8

	.editor-control-input-angle.dark-mini.change-process

		.control-number

			.angle-input
				border: 1px solid #20a8d8

	.editor-control-input-angle.dark-medium

		.control-number

			.number-input
				height: 30px
				border: 1px solid #23282c
				border-radius: 0.25rem
				background: #515b65
				transition: none

				&:focus
					outline: none
					box-shadow: none
					background: #515b65
					border: 1px solid rgba(255, 255, 255, 0.3)

				&:hover
					outline: none
					box-shadow: none
					background: #515b65
					border: 1px solid rgba(255, 255, 255, 0.3)

				label


				input
					padding: 0 7px


			.angle-input
				margin-left: 10px

			.angle-input:hover
				background-color: rgba(255, 255, 255, 0.1)
				border: 1px solid rgba(255, 255, 255, 0.4)

	.editor-control-input-angle.dark-medium.change-process

		.control-number

			.angle-input
				border: 1px solid #20a8d8


</style>
